<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M12.0002 19.7678V22.0982M3.45557 22.0982H20.5449M8.89307 10.4464H15.1074M8.89307 13.5536H15.1074"
            class="stroke-(--icon-primary)"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M4.25807 9.57997L4.23731 15.8787C4.23447 16.7388 4.93086 17.4374 5.79087 17.4374H18.2143C19.0724 17.4374 19.7679 16.7419 19.7679 15.8839V9.5847C19.7679 9.1443 19.581 8.72457 19.2537 8.42995L12 1.90173L4.77027 8.4322C4.44549 8.72556 4.25951 9.14231 4.25807 9.57997Z"
            class="stroke-(--icon-secondary)"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
